import { dataCandidateData } from './dataCandidateData';
import { dataCustomStats } from './dataCustomStats';
import { dataDeviceData } from './dataDeviceData';
import { dataExamResults } from './dataExamResults';
import { dataScore } from './dataScore';
import { dataUserSessionDetails } from './dataUserSessionDetails';

export const dataPersonVORaw = {
  type: 'object',
  required: [
    'CandidateData',
    'DeviceData',
    'CustomStats',
    'ExamResults',
    'Score',
    'UserSessionDetails',
  ],
  properties: {
    CandidateData: dataCandidateData,
    DeviceData: dataDeviceData,
    CustomStats: dataCustomStats,
    ExamResults: dataExamResults,
    Score: dataScore,
    UserSessionDetails: dataUserSessionDetails,
  },
};
